import {
    CHAT_LIST_GET_LIST,
    CHAT_LIST_GET_LIST_SUCCESS,
    CHAT_LIST_GET_LIST_ERROR,
    CHAT_LIST_GET_LIST_WITH_FILTER,  
    CHAT_GET,
    CHAT_GET_SUCCESS,
    CHAT_GET_ERROR
} from '../actions';


export const getChatList = (pid,items,offset) => ({
    type: CHAT_LIST_GET_LIST,
    pid,items,offset
});

export const getChatListSuccess = (chats,currentUser,loadchats) => ({
    type: CHAT_LIST_GET_LIST_SUCCESS,
    payload: {chats,currentUser,loadchats}
});

export const getChatListError = (error) => ({
    type: CHAT_LIST_GET_LIST_ERROR,
    payload: error
});

export const getChat = (sessionID) => ({
    type: CHAT_GET,
    payload:sessionID
});

export const getChatSuccess = (chat,loadchats) => ({
    type: CHAT_GET_SUCCESS,
    payload: {chat,loadchats}
});

export const getChatError = (error) => ({
    type: CHAT_GET_ERROR,
    payload: error
});

export const getChatListWithFilter = (column, value) => ({
    type: CHAT_LIST_GET_LIST_WITH_FILTER,
    payload: { column, value }
});

export const getChatListSearch = (startDate,endDate,hotel) => ({
    type: CHAT_LIST_GET_LIST_WITH_FILTER,
    payload: {startDate,endDate,hotel}
});